const mapPaymentState = (tokenResponse) => {
  switch (tokenResponse?.state.key) {
    case "order-payment-authorized":
    case "order-paid":
    case "order-submitted":
      return "Paid";
    case "order-cancelled":
      return "Failed";
    default:
      return void 0;
  }
};
export {
  mapPaymentState
};
//# sourceMappingURL=payment-state.js.map
